import React from 'react';
import { Zap, Home, ShieldCheck, TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const iconMap = {
  'Zap': Zap,
  'Home': Home,
  'ShieldCheck': ShieldCheck,
  'TrendingUp': TrendingUp
};

export const Benefits = () => {
  const { t } = useTranslation();
  
  // Get benefits dynamically based on current language
  const benefits = [
    { id: 1, title: t('benefits.item1.title'), description: t('benefits.item1.description'), icon: "Zap", percentage: "60%" },
    { id: 2, title: t('benefits.item2.title'), description: t('benefits.item2.description'), icon: "Home", percentage: "100%" },
    { id: 3, title: t('benefits.item3.title'), description: t('benefits.item3.description'), icon: "ShieldCheck", percentage: "24/7" },
    { id: 4, title: t('benefits.item4.title'), description: t('benefits.item4.description'), icon: "TrendingUp", percentage: "+20%" }
  ];
  
  return (
    <section id="benefits" className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#C5A35C]/5 to-transparent" />
      <div className="absolute bottom-0 left-0 w-1/3 h-full bg-gradient-to-r from-[#C5A35C]/5 to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#C5A35C]/10 border border-[#C5A35C]/20 mb-6">
            <span className="text-[#C5A35C] text-sm font-semibold">{t('benefits.simple.badge')}</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t('benefits.simple.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('benefits.simple.description')}
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div
                key={benefit.id}
                className="group relative"
                style={{ animationDelay: `${index * 100}ms` }}>

                {/* Card */}
                <div className="relative h-full p-8 rounded-2xl bg-white border-2 border-gray-100 hover:border-[#C5A35C]/30 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2">
                  {/* Percentage Badge */}
                  <div className="absolute -top-4 right-8">
                    <div className="px-4 py-2 rounded-full bg-gradient-to-r from-[#C5A35C] to-[#B8933D] text-white font-bold text-sm shadow-lg">
                      {benefit.percentage}
                    </div>
                  </div>

                  {/* Icon */}
                  <div className="mb-6 inline-flex p-4 rounded-2xl bg-gradient-to-br from-[#C5A35C]/10 to-[#C5A35C]/5 group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-8 h-8 text-[#C5A35C]" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>

                  {/* Bottom Accent */}
                  <div className="absolute bottom-0 left-8 right-8 h-1 bg-gradient-to-r from-[#C5A35C] to-[#B8933D] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 rounded-full" />
                </div>
              </div>);

          })}
        </div>
      </div>
    </section>);

};